import { ENV } from '../utils/http'

export default (state = { loading: true, list: [], edit: undefined }, action) => {

  switch (action.type) {
    case 'USERS_FETCH_BEGIN':
      return { ...state, loading: true };
    case 'USERS_FETCH_SUCCESS':
      return { ...state, list: action.payload.list, orgName: action.payload.orgName, orgId: action.payload.orgId, loading: false };
    case 'USERS_SAVE_SUCCESS':
      return { ...state, list: action.payload.list, edit: undefined };
    case 'USERS_SAVE_FAILURE':
      alert('E-postadressen finns redan');
      return state;
    case 'USERS_EDIT':
      return { ...state, edit: action.payload };
    case 'USERS_CANCEL_EDIT':
      return { ...state, edit: undefined };
    case 'USERS_DELETE_SUCCESS':
    case 'USERS_INACTIVATE_SUCCESS':
    case 'USERS_ACTIVATE_SUCCESS':
      return { ...state, list: action.payload.list, edit: undefined };
    case 'USERS_RESET_PASSWORD_SUCCESS':
      alert('En länk har skickats till användaren för att återställa lösenordet');
      return { ...state, list: action.payload.list, edit: undefined };
    case 'USER_ATTR_EDIT':
      let user = state.edit;
      user[action.payload.attr] = action.payload.value;
      return { ...state, edit: user };
    case 'USERS_LOGIN_SUCCESS':
      let url = `${ENV.previewUrl}/loggain/${action.payload.confirmationKey}`;
      window.open(url, '_blank');
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/user/userReducers.js